import style from "./Emotion.module.css";
import { ref, update } from "firebase/database";
import { db } from "../../../configs/Firebase";
import Icon from "../../../designSystem/a-atoms/icons/Icon";
import { useEffect, useState } from "react";

const Emotion = (props) => {
  const [rowData, setRowData] = useState(false);
  const [row, setRow] = useState(false);

  useEffect(() => {
    if (props.row) {
      setRowData(props.row);
    }
  }, [props.row]);

  useEffect(() => {
    if (rowData) {
      let tempColumns = [];
      for (let i in rowData.columns) {
        tempColumns.push({
          id: i,
          ...rowData.columns[i],
        });
      }

      rowData.columns = tempColumns;

      setRow(rowData);
    }
  }, [rowData]);

  function tickUp(columnId, columnVal) {
    update(ref(db), {
      [props.journeyRefURL +
      "/rows/" +
      props.row.id +
      "/columns/" +
      columnId +
      "/value"]: columnVal + 1,
    });
  }

  function tickDown(columnId, columnVal) {
    update(ref(db), {
      [props.journeyRefURL +
      "/rows/" +
      props.row.id +
      "/columns/" +
      columnId +
      "/value"]: columnVal - 1,
    });
  }

  function getCurve(start, end) {
    let topLeft = 1 * (100 - (start - 1) * 20);
    let topRight = 1 * (100 - (end - 1) * 20);
    return (
      <div className={style.svgContainer}>
        <svg viewBox="0 0 200 100" preserveAspectRatio="none">
          <path
            fill="none"
            stroke="var(--on--400)"
            strokeWidth="2"
            d={
              "M 0 " +
              topLeft +
              " C 100 " +
              topLeft +
              ", 100 " +
              topRight +
              ", 200 " +
              topRight +
              ""
            }
          />
        </svg>
      </div>
    );
  }

  return (
    <div className={`${style.cell}`}>
      <span style={{ "--num": props.data.value }}>
        {props.editable && props.data.value < 6 ? (
          <span
            className={style.up}
            onClick={() => tickUp(props.cellIndex, props.data.value)}
          >
            <Icon>keyboard_arrow_up</Icon>
          </span>
        ) : null}
        {props.data.value === 6 ? <>&#128512;</> : null}
        {props.data.value === 5 ? <>&#128578;</> : null}
        {props.data.value === 4 ? <>&#128528;</> : null}
        {props.data.value === 3 ? <>&#128533;</> : null}
        {props.data.value === 2 ? <>&#128543;</> : null}
        {props.data.value === 1 ? <>&#128545;</> : null}
        {props.editable && props.data.value > 1 ? (
          <span
            className={style.down}
            onClick={() => tickDown(props.cellIndex, props.data.value)}
          >
            <Icon>keyboard_arrow_down</Icon>
          </span>
        ) : null}
      </span>

      {row &&
        props.index + 1 !== row.columns.length &&
        getCurve(
          props.data.value,
          props.row.columns[props.index + 1]
            ? props.row.columns[props.index + 1].value
            : 0
        )}
    </div>
  );
};

export default Emotion;
